<template>

  <div v-if="showModal" @click.self="hide" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
    <div class="w-full sm:w-1/2 lg:w-3/5 bg-white rounded-lg mx-6">

      <div class="rg-modal-header">
        <span>Assign AI Phone Number</span>

        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="hide"><i class="mdi mdi-close"></i></a>
      </div>

      <div class="p-6">

        <div class="mb-4 p-3 bg-gray-100 rounded">
          <p class="text-xs font-semibold mb-2">Choose agents for this number</p>
          <label class="block text-sm mb-2"><input type="checkbox" v-model="createVoiceAgent" :disabled="sending || assigning"> Create voice agent</label>
          <label class="block text-sm"><input type="checkbox" v-model="createSmsAgent" :disabled="sending || assigning"> Create SMS agent</label>
          <p class="text-xs text-gray-600 mt-2">SMS AI only responds when explicitly enabled. Editing a prompt does not enable it. With voice off, this number will not answer calls.</p>
        </div>
        <v-tabs>
          <v-tab v-if="$store.state.auth.owner && 0">Select Number</v-tab>
          <v-tab>Purchase New Number</v-tab>

          <v-tab-item v-if="$store.state.auth.owner && 0" class="pt-5">
            <p class="mb-1 text-xs mb-2"><strong>Select Existing Phone Number</strong></p>
                          
            <v-select v-if="!gettingTwilioNumbers"
                  v-model="selected_phone_number"
                  flat
                  solo-inverted
                  hide-details
                  :items="numbers"
                  label="Select Number"
                  class="-mt-2"
              ></v-select>

            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 mt-4" :class="{'spinner': assigning}" @click="assignSelectedNumber()">
                ASSIGN
            </button>
          </v-tab-item>

          <v-tab-item class="pt-5">
            <div class="flex flex-wrap mb-2">
                <div class="w-full md:w-2/3 mb-4">
                  <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4 mt-1" role="warning">
                    <div>Purchasing a phone number is the first step in creating your AI agent. Use the search below to choose a number in your country and area code.</div>
                  </div>

                  <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">
                    {{success}}
                  </div>

                  <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                    <div v-html="error"></div>
                  </div>

                  <div class="mb-3">
                    <p class="mb-1 text-xs mb-2"><strong>Country</strong></p>
                    <v-select
                      :items="countries"
                      label=""
                      item-text="name"
                      item-value="code"
                      hide-details
                      v-model="country"
                      class="-mt-2"
                      dense
                      outlined
                    ></v-select>
                  </div>

                  <div class="mb-3">
                    <p class="mb-1 text-xs mb-2"><strong>Area Code</strong></p>

                    <input name="text" ref="area_code" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" v-on:keyup.enter="save">
                  </div>

                  <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4" :class="{'spinner': sending}" @click="save">
                      SEARCH
                  </button>

                  <div v-if="numbers_found.length > 0" style="font-size: 12px;">
                      <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4 mt-1" role="warning">
                        <div>Great! We found <strong>{{ numbers_found.length }}</strong> numbers available. Please choose one by clicking on the "Buy" button to the right of the number. We immediately grant the phone number to your account and you can configure your AI agent.</div>
                      </div>
                      
                      <div v-for="(item, index) in numbers_found" :key="index">
                          {{ item }}

                          <a href="javascript: void(0);" class="float-right" @click="buyNumber(item)">Buy</a>

                          <div style="clear: both; margin-top: 3px; margin-bottom: 3px;"></div>

                          <hr />
                      </div>
                  </div>
                </div>

                <div class="w-full md:w-1/3 pl-4">
                  <p class="mb-1 text-xs mb-2"><strong>Instructions</strong></p>

                  <iframe width="300" height="300" src="https://www.loom.com/embed/c3da89f3e6994aebb9652ab1f1666d30" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </div>
            </div>
          </v-tab-item>

        </v-tabs>

      </div>

      <div class="bg-gray-100 rounded-b-lg px-6 py-4">

        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="hide">
            CANCEL
        </button>

        <div class="clearfix"></div>

      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import countries from '@/config/countries';

export default {
  props: ['inbox'],

  data: function() {
    return {
      showModal: false,
      createVoiceAgent: true,
      createSmsAgent: false,
      sending: false,
      success: null,
      error: null,

      country: "US",

      countries: countries,

      numbers: [],

      numbers_found: [],

      savingTwilio: false,
      errorTwilio: null,
      gettingTwilioNumbers: false,
      show_auth_token: false,

      selected_phone_number: null,

      assigning: false
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me
    })
  },
  methods: {
    show() {
      this.createVoiceAgent = true
      this.createSmsAgent = false
      this.showModal = true
    },
    hide() {
      this.showModal = false
      this.sending = false
    },
    async getTwilioNumbers() {

      this.gettingTwilioNumbers = true

      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/get-twilio-numbers`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.gettingTwilioNumbers = false
        this.numbers = response.data.numbers;
      }

      this.gettingTwilioNumbers = false

    },

    async save() {
      if (this.sending) return
      this.sending = true
      this.success = null
      this.error = null
      this.numbers_found = []
      try {

        let formData = new FormData();
        formData.append("country", this.country);
        formData.append("area_code", this.$refs.area_code.value);

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/search-phone-numbers`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
              'Content-Type': 'multipart/form-data'
            }
        })

        //this.hide()
        // this.hide()
        // this.$store.state.contacts.fetchingContacts = true

        this.numbers_found = response.data.numbers;

        if (this.numbers_found.length === 0) {
          this.error = 'No phone numbers are available for this country and area code. Please try a different area code or search again later.';
        }

      } catch (e) {
        for (var i in e.response.data.errors) {
            if (e.response.data.errors[i] != 'null') {
              console.log(e.response.data.errors[i]);
              this.error = (this.error || '') + e.response.data.errors[i] + "<br />";
            }
        }
      }
      this.sending = false
    },
    async buyNumber(phoneNumber) {
      if (this.sending) return
      this.sending = true
      this.success = null
      this.error = null
      try {

        let formData = new FormData();
        formData.append("phoneNumber", phoneNumber);
        formData.append("create_voice_agent", this.createVoiceAgent ? '1' : '0');
        formData.append("create_sms_agent", this.createSmsAgent ? '1' : '0');

        if (this.inbox)
          formData.append("inbox", 1);

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/buy-number`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
              'Content-Type': 'multipart/form-data'
            }
        })

        this.hide()

        window.location = window.location.href;

      } catch (e) {
        console.log(e);
        for (var i in e.response.data.errors) {
            if (e.response.data.errors[i] != 'null') {
              console.log(e.response.data.errors[i]);
              this.error = (this.error || '') + e.response.data.errors[i] + "<br />";
            }
        }
      }
      this.sending = false
    },

    async assignSelectedNumber(phoneNumber) {
      this.assigning = true
      this.success = null
      this.error = null

      let formData = new FormData();
      formData.append("selected_phone_number", this.selected_phone_number);

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/assign-selected-number`, formData, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
            'Content-Type': 'multipart/form-data'
          }
      })

      this.hide()

      window.location = window.location.href;

      this.assigning = false
    }
  },

  created() {
    this.getTwilioNumbers();
  }
}
</script>
